export default {
  getMessage: field => `${field} is not a valid postal code`,
  validate(value) {
    return new Promise((resolve) => {
      const canadianPostalCode = /^(?!.*[DFIOQU])[A-VXY][0-9][A-Z] ?[0-9][A-Z][0-9]$/gm;
      const americanPostalCode = /^[0-9]{5}(?:-[0-9]{4})?$/gm;
      resolve({
        valid:
          value.match(canadianPostalCode) || value.match(americanPostalCode),
      });
    });
  },
};
